const initalState = {
  showDeletePopup: false,
  noForms: false,
  isLoading: true,
  Heading: "",
  alerts: {
    message: "Loading...",
    variant: "info",
  },
  forms: [],
  currentForm: {},
  showFormBuilder: false,
};

const FormListReducer = (state = initalState, action) => {
  switch (action.type) {
    case "update-state":
      return {
        ...state,
        ...action.state,
      };

    default:
      return state;
  }
};

export default FormListReducer;
